import hljs from 'highlight.js'
import 'highlight.js/styles/rainbow.css';

export default {
    highlightCode(el) {
        var targets = el.querySelectorAll('pre')
        targets.forEach((target) => {
          target.setAttribute("class", "swift")
          hljs.highlightBlock(target)
      })
      }
}